import { formatMixtureDecimal, type MixtureUsage } from '../../utils/mixturesMapper';
import { formatConcentration } from './MixtureUsageSummary';
import { MixtureTank } from './MixtureTank';
import styles from './MixtureBoxLimits.module.css';

interface MixtureBoxLimitsProps {
	usage: MixtureUsage;
	vbox: number;
	productCount: number;
}

const litersFormatter = new Intl.NumberFormat('pt-BR');

export const MixtureBoxLimits = ({ usage, vbox, productCount }: MixtureBoxLimitsProps) => {
	const isEmpty = productCount === 0;
	const rows = [
		{
			label: 'Adubo',
			value: `${formatMixtureDecimal(usage.massKg)} de ${formatMixtureDecimal(usage.massLimitKg)} kg`,
		},
		{
			label: 'Concentração',
			value: `${formatConcentration(usage.concentration)} de ${formatConcentration(usage.cemMax)} g/L`,
		},
		{ label: 'Caixa', value: `${litersFormatter.format(vbox)} L` },
		{ label: 'Produtos', value: String(productCount) },
	];

	return (
		<div className={styles.card}>
			<span className={styles.label}>Limites da caixa</span>
			<MixtureTank filled={!isEmpty} size="large" />
			<strong className={styles.percent}>{usage.percentage}%</strong>
			<span className={styles.caption}>{isEmpty ? 'tanque vazio' : 'do limite da caixa'}</span>
			<dl className={styles.rows}>
				{rows.map((row) => (
					<div key={row.label} className={styles.row}>
						<dt className={styles.rowLabel}>{row.label}</dt>
						<dd className={styles.rowValue}>{row.value}</dd>
					</div>
				))}
			</dl>
		</div>
	);
};
